
import * as R from 'ramda'
import { call, reducer } from '../../../helpers/api/meta'
import { getCourseDiscussions } from '../../../helpers/api/api';

export const GET_COURSE_DISCUSSIONS = 'GET_COURSE_DISCUSSIONS'

export const callGetCourseDiscussions = (inputs) => {
    const meta = {
        endpoint: (params) => getCourseDiscussions(params),
        inputs,
        action: GET_COURSE_DISCUSSIONS,
        messages: {
            id: 'getCourseDiscussions',
            failure: 'Could not get course discussions'
        }
    }
    return call(meta)
}

const initialState = {
    loading: false,
    results: []
}

const saveCourseDiscussions = (state, action) => {
    return R.assoc('results', action.results, state);
}

const messages = {
    loadFailed: 'Could not load discussion.',
}

export default reducer(initialState, GET_COURSE_DISCUSSIONS, saveCourseDiscussions, messages.loadFailed)